var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"act-button",class:{ disabled: _vm.disabled },on:{"click":_vm.clickBtn}},[_c('a',{staticClass:"act-btn",class:[_vm.feedKind],attrs:{"href":"javascript:;"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }